import styled, { css } from "styled-components";

export const StyledTitleSection = styled.div<{ isCollapsed: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > .meeting-agent-section-title {
        margin-bottom: 0;
    }
    transition: margin-bottom 0.3s ease-in-out;

    ${({ isCollapsed }) =>
        !isCollapsed &&
        css`
            margin-bottom: 12px;
        `}
`;
